export default __webpack_public_path__ + "static/media/greece20-el.5434e3ad.jpg";